import ProjectCard from "./ProjectCard";

const projectData = [
  {
    name: "FeastFleet",
    id: "1_FeastFleet",
    // imageLink: "https://img.icons8.com/fluency/480/pizza-delivery.png",
    imageLink: "",
    tech: "React, Tailwind, Redux, Swiggy API, Vercel",
    codeLink: "https://github.com/Hrithik06/FeastFleet",
    demoLink: "https://feastfleet.vercel.app/",
  },
  {
    name: "aimax",
    id: "3_NetflixGPT",
    imageLink: "https://img.icons8.com/color/480/netflix.png",
    tech: "React, ChatGPT API, Firebase,Tailwind", 
    codeLink: "https://github.com/Hrithik06/aimax",
    demoLink: "https://aimax-c4f30.web.app/",
  },
  {
    name: "YouTube Clone",
    id: "2_YoutubeClone",
    imageLink: "https://img.icons8.com/color/480/youtube-play.png",
    tech: "React, Tailwind, Redux, YouTube API, Vercel",
    codeLink: "",
    demoLink: "",
  },
  
];

const Project = () => {
  return (
    <div className="p-5">
      <h2 className="text-3xl mt-10  ">Projects</h2>
      <div className="border-t-2 w-1/12 border-solid border-neutral-400  h-2  mb-10 "></div>
      <p className="px-2 text-xl">
      Here are a few projects I've completed or currently working on, where I've expanded my skills and delved into exploring new technologies.
      </p>


      <div className="projects my-10  flex justify-between flex-wrap">
        {projectData.map((proj) => {
          return <ProjectCard key={proj.id} projData={proj} />;
        })}
      </div>
    </div>
  );
};

export default Project;
